import React, { useState } from 'react';

import Micropalette from "../../Micropalette";
import { API } from "../../BlakeData";

import { PrintRecord, SwatchObject } from "../../BlakeData/Types";

interface EditionMicropaletteProps {

    paletteID: string;
    prints: Array<PrintRecord>;
    title: string;
    height?: number;
    paletteWidth?: number;
    padding?: number;
    maxWidth: number;
    visible: boolean;
}

export function EditionMicropalette(props: EditionMicropaletteProps) {

    const paletteWidth = props.paletteWidth || 10,
        height = props.height || 100,
        padding = props.padding || 2;

    const [palettes, setPalettes] = useState<SwatchObject[][]>([[]]);

    // initialize with a collection of empty swatches so that the 
    // canvas starts with a correct initial size
    // const dummySwatch:SwatchObject = {percent: 5, color: [0,0,0]}
    // const [palettes, setPalettes] = useState<SwatchObject[][]>(Array(props.prints.length).fill(dummySwatch));

    let [loaded, setLoaded] = useState<boolean>(false);
    
    if (props.visible === false){ return (null)}

    if (!loaded) {
        // console.log(`Getting ${props.prints.length} items`)
        API.getFullPrintObjects(props.prints.map(p => p.id)).then((printObjects: Array<PrintRecord>) => {
            const newPalettes = API.makeSwatchArray(printObjects);
            setPalettes(newPalettes);
            setLoaded(true);
        })
    }
    
    let paletteArrays = [palettes];

    return (<div>
        {
            paletteArrays.map((palette, i) => {
                return <Micropalette
                    key={i}
                    height={height}
                    paletteWidth={paletteWidth}
                    padding={padding}
                    id={`micropalette-${props.paletteID}-i`}
                    palettes={palettes}
                    itemCount={props.prints.length}
                    // setIndexValue={props.setIndexValue}
                />
            })
        }
    </div>)

}
